'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var backup = require('./backup.js');
var restore = require('./restore.js');
var autokeys = require('./autokeys.js');
var checkquery = require('./checkquery.js');
var schemaready = require('./schemaready.js');
var typenames = require('./typenames.js');
var filepolicy = require('./filepolicy.js');



exports.backup = backup.backup;
exports.restore = restore.restore;
exports.getAutoKeys = autokeys.getAutoKeys;
exports.checkQuery = checkquery.checkQuery;
exports.isSchemaReady = schemaready.isSchemaReady;
exports.getTypeNames = typenames.getTypeNames;
exports.checkFilePolicy = filepolicy.checkFilePolicy;
